import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import Star from './star';

const Rating = ({ stars, size = 16 }) => {
  const starElements = useMemo(
    () => Array.from({ length: stars }, (_, index) => <Star key={index} size={size} />),
    [size, stars]
  );

  return <div className="ws-difm-rating">{starElements}</div>;
};

Rating.propTypes = {
  stars: PropTypes.number.isRequired,
  size: PropTypes.number,
};

export default Rating;
